import { forgotPassword, verifyForgotPassword, resetPassword } from '@/apis/forgot-password';
import { FORGOT_PASSWORD } from '../mutation-types';

export const state = {
  forgotPassword: '',
  verifyForgotPassword: '',
  resetPassword: '',
};

export const getters = {};

export const mutations = {
  [FORGOT_PASSWORD.FORGOT_PASSWORD](state, data) {
    state.forgotPassword = data;
  },
  [FORGOT_PASSWORD.VERIFY_FORGOT_PASSWORD](state, data) {
    state.verifyForgotPassword = data;
  },
  [FORGOT_PASSWORD.RESET_PASSWORD](state, data) {
    state.resetPassword = data;
  },
};

export const actions = {
  async forgotPassword({ commit }, payload) {
    const res = await forgotPassword(payload);
    if (res.error) {
      return res.error.response.data;
    }
    if (res) {
      return res;
    }
    // commit(FORGOT_PASSWORD.FORGOT_PASSWORD, res);

    return false;
  },

  async verifyForgotPassword({ commit }, payload) {
    const res = await verifyForgotPassword(payload);
    if (res.error) {
      return res;
    }
    commit(FORGOT_PASSWORD.FORGOT_PASSWORD, res);

    return false;
  },

  async resetPassword({ commit }, payload) {
    const res = await resetPassword(payload);
    if (res.error) {
      return res;
    }
    commit(FORGOT_PASSWORD.FORGOT_PASSWORD, res);

    return false;
  },
};
